<template>
    <div id='main-content' class='main-content main-padding container-fluid' v-infinite-scroll='scroll'>
        <!-- Search -->
        <div class='row hidden-print'>
            <div class='col-md-3'><!--Empty div forces text input to the left--></div>
            <div class='col-md-7 search-wrapper'>
                <!--
                    The difference between these inputs is the button img/styling.
                    Unfortunately bootstrap input-group-btn renders square edges
                    as though each button is visible even if one is hidden
                -->
                <!-- Search bar and button Desktop -->
                <div class='input-group hidden-sm hidden-xs'>
                    <input name='search'
                        type='text'
                        class='form-control'
                        v-model.trim='search_words'
                        @keyup.enter='search(search_words)'
                        placeholder="Search by keyword, artist/maker, subject, etc." />
                    <div class='input-group-btn'>
                        <button class='btn bg-lime-green'
                            type='button'
                            @click='search(search_words)'>
                            <img src="/images/search_icon_white.svg">
                        </button>
                    </div>
                </div>

                <!-- Search bar and button Mobile -->
                <div class='mobile-search input-group hidden-md hidden-lg'>
                    <input name='search'
                        type='text'
                        class='form-control'
                        v-model.trim='search_words'
                        @keyup.enter='search(search_words)'
                        placeholder="Search by keyword, artist/maker, subject, etc." />
                    <div class='input-group-btn'>
                        <button class='btn' type='button' @click='search(search_words)'>
                            <img src="/images/search_icon_green.svg">
                        </button>
                    </div>
                </div>
            </div>
            <div class='col-md-2 hidden-sm hidden-xs advanced-desktop hidden-print'>
                <router-link :to="{name: 'advanced'}">
                    Advanced Search
                </router-link>
            </div>
        </div>

        <!-- Enlarged OpenSeadragon Viewer -->
        <media-viewer></media-viewer>

        <!-- Detailed View-->
        <router-view></router-view>

        <div id='result-format'>
            <div class='row'>
                <!-- Count Results -->
                <div :class="{'hidden-print': $route.name != 'search'}" class='col-md-4 col-lg-6 col-xs-5'>
                    <span v-if='filter_manager.filters.search.selected.length > 0' class='hidden-xs hidden-sm'>
                        {{total}} results found for <strong>{{filter_manager.filters.search.selected[0]}}</strong>
                    </span>
                    <span v-else class='hidden-xs hidden-sm'>{{total}} results found</span>
                    <span class='hidden-md hidden-lg'>{{total}} results</span>
                </div>

                <!-- View Controls-->
                <div class='col-md-8 col-lg-6 view-controls hidden-print'>
                    <div class='form-inline pull-right'>
                    <!-- View -->
                        <div class='form-group hidden-xs hidden-sm'>
                            <label>View</label>
                            <button class='btn bg-blue' :class='{"bg-gray": mobile_manager.grid_view}'
                                    @click='exitEnterGrid(false)'>Full List
                            </button>
                            <button class='btn bg-blue' :class='{"bg-gray": !mobile_manager.grid_view}'
                                    @click='exitEnterGrid(true)'>Images Only
                            </button>
                        </div>

                        <!-- Desktop Sort By-->
                        <div class='form-group hidden-xs hidden-sm'>
                            <label for='sort_by'>Sort by</label>
                            <select id='sort_by' class='form-control' v-model='selected_sort' @change='sort'>
                                <option value='_score'>Relevance</option>
                                <option value='sortable_title-keyword'>Title</option>
                                <option value='sortable_type-keyword'>Object</option>
                                <option value='sortable_creator-keyword'>Creator/Author</option>
                                <option value='sortable_year'>Date</option>
                            </select>
                        </div>

                        <!-- Mobile Advanced Search and Filter -->
                        <div class='form-group hidden-md hidden-lg'>
                            <router-link :to="{name: 'advanced'}">Advanced Search</router-link>
                            <button class='btn facet-btn bg-lime-green' type='button' @click='mobile_manager.toggleFilter()'>
                            Filter
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Results -->
        <div id='results' :class="{'hidden-print': $route.name != 'search'}">
            <div class='row'>
                <!-- Facets -->
                <div class='facet-wrapper hidden-md hidden-lg' v-show='mobile_manager.open_filters' @click='mobile_manager.toggleFilter()'>
                    <!-- Put dark overlay if facets are open -->
                </div>
                <transition name='slide'>
                    <div id='facets' class='col-md-3 hidden-print' v-show='mobile_manager.open_filters'>
                        <!-- Mobile Sort By-->
                        <div class='form-group hidden-md hidden-lg mobile-sort-by'>
                            <label for='sort_by'>Sort by</label>
                            <select id='sort_by' class='form-control' v-model='selected_sort' @change='sort'>
                                <option value='_score'>Relevance</option>
                                <option value='sortable_title-keyword'>Title</option>
                                <option value='sortable_type-keyword'>Object</option>
                                <option value='sortable_creator-keyword'>Creator/Author</option>
                                <option value='sortable_year'>Date</option>
                            </select>
                        </div>

                        <facets></facets>
                    </div>
                </transition>
                <div id='record_col' class='col-md-9'>
                    <!-- Selected Facets -->
                    <selected-facets></selected-facets>
                    <hr class='hidden-md hidden-lg'>

                    <!-- Objects -->
                    <div v-if='object_groups.length != 0'>
                        <div class='row'>
                            <div v-for='(objects, index) in object_groups'>
                                <!-- List Summary -->
                                <div class='row'>
                                    <template v-for='object in objects'>
                                        <!-- <div class='clickable'> -->
                                        <div>
                                            <record-summary :objWithSource='object'></record-summary>
                                        </div>
                                    </template>
                                </div>

                                <!-- Grid Summary -->
                                <div class='mobile-wrapper row'>
                                    <template v-for='(object, index) in objects'>
                                        <!-- Summary -->
                                        <transition name='slide'>
                                            <div v-show='object._source.open_summary && mobile_manager.grid_view' class='col-md-12'>
                                                <!-- Grid view Dropdown summary -->
                                                <mobile-expanded :objWithSource='object' :index='index + 1'></mobile-expanded>
                                            </div>
                                        </transition>
                                    </template>
                                </div>
                            </div>
                        </div>
                        <div v-show='!more_to_load'>
                            <div class='loader no-results'>
                                No more results found
                            </div>
                        </div>
                    </div>
                    <div v-show='loading'>
                        <div class='loader'>
                            <img src="/images/mariners-loading-icon.gif" width='35px'>
                        </div>
                    </div>
                    <div v-show='object_groups.length == 0 && !loading'>
                        <div class='loader no-results'>
                            No results meet your criteria
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <scroll-to-top-button class='hidden-print' :total='total'>
        </scroll-to-top-button>
    </div>
</template>

<script>
    import manageProperties from './../mixins/manageProperties.js'
    import SummaryVue from './summaries/summary.vue'
    import MobileExpandedVue from './summaries/mobileExpanded.vue'
    import FacetsVue from './facets/base.vue'
    import SelectedFacetsVue from './facets/selected.vue'
    import mediaViewerVue from './mediaViewer.vue'
    import ScrollToTopButtonVue from './scrollToTopButton.vue'
    import EventHub from './eventHub.js'
    import RouteManager from './routeManager.js'
    import FilterManager from './filterManager.js'
    import MobileManager from './mobileManager.js'

    export default {
        mixins: [manageProperties],
        components: {
            'facets': FacetsVue,
            'record-summary': SummaryVue,
            'mobile-expanded': MobileExpandedVue,
            'selected-facets': SelectedFacetsVue,
            'media-viewer': mediaViewerVue,
            'scroll-to-top-button': ScrollToTopButtonVue,
        },
        data: function () {
            return {
                filter_manager: FilterManager,
                mobile_manager: MobileManager,
                current_size: null,
                search_words: '',
                loading: false,
                more_to_load: true,
                object_groups: [],
                scrolling: false,
                actual_sort: null,
                selected_sort: '_score',
                total: 0
            }
        },
        created: function () {
            window.document.title = "Search - The Mariners' Museum Online Catalog"
            var description = "At The Mariners' Museum, explore over 60,000 square feet of gallery space with rare figureheads, handcrafted ship models, Civil War ironclad USS Monitor artifacts, paintings, and much more."
            $('meta[name=description]').attr('content', description)
            window.document.description = description

            var self = this
            EventHub.$on('open-summaries', this.openSummaries)

            // When the component is first mounted fetch search data
            this.$nextTick(function () {
                var query = $.extend({}, this.$route.query);

                // NOTE: We no ignore this b/c we don't update the url with page info
                // when scrolling.
                // When mounted remove pagination as we want to load from start
                // But only if the page is found in the query params otherwise
                // it will cause a redirect when accessing child url directly
                RouteManager.clearPage()

                // Add filters from url
                this.filter_manager.addByQuery(query)

                // Add sort from url
                if (query.sort) {
                    this.actual_sort = query.sort
                    this.selected_sort = query.sort
                } else {
                    this.actual_sort = null
                    this.selected_sort = '_score'
                }

                this.fetchResults()
                // Hide filters and force list view if mobile
                this.prepMobile()
                // if viewing by images
                if (this.filter_manager.filters.media.selected.indexOf('Images') != -1) {
                    this.exitEnterGrid(true)
                }
            })

            // Close facets if window becomes
            $(window).on('resize', function () {
                self.prepMobile()
            })
        },
        beforeDestroy: function () {
            EventHub.$off('open-summaries')
        },
        methods: {
            prepMobile: function () {
                var self = this
                // Only trigger if we are moving from desktop size to mobile size or if it is the initial load.
                // This prevents bugs where scrolling on mobile closes the filters
                if (window.innerWidth < 992 && (this.current_size >= 992 || this.current_size == null)) {
                    this.mobile_manager.grid_view = false
                    this.mobile_manager.open_filters = false
                    this.mobile_manager.mobile_view = true

                } else if (window.innerWidth >= 992 && (this.current_size < 992 || this.current_size == null)) {
                    this.mobile_manager.open_filters = true
                    this.mobile_manager.mobile_view = false
                }

                this.current_size = window.innerWidth
            },

            // When one summary is open close all other summaries
            openSummaries: function (current) {
                var self = this
                // Close all other open summaries
                var timeout = 0
                this.object_groups.forEach(function (objects) {
                    objects.forEach(function (object) {
                        if (object._source._id != current._id && object._source.open_summary) {
                            if (self.mobile_manager.grid_view) {
                                timeout = 300
                            }
                            object._source.open_summary = false
                        }
                    })
                })

                // Delay allows other summaries to be closed first
                setTimeout(function () {
                    current.open_summary = !current.open_summary
                }, timeout)
            },

            // Search for search words
            search: function (search_words) {
                // Set search filter
                if (search_words) {
                    this.filter_manager.addByField('query', search_words)
                } else {
                    this.filter_manager.clearFilter('search')
                }

                // Set query param
                var query = $.extend({}, this.$route.query)
                query.query = search_words

                // Unset page param (start from beginning)
                RouteManager.clearPage()

                // Reset router (watcher will trigger fetching results)
                this.scrolling = false
                this.$router.push({name: 'search', query: query})
            },

            // Add sort by to query params and push new route
            sort: function (search_words) {
                // Set query param
                var query = $.extend({}, this.$route.query)
                query.sort = this.selected_sort
                this.actual_sort = this.selected_sort

                // Unset page param (start from beginning)
                RouteManager.clearPage()

                // Reset router (watcher will trigger fetching results)
                this.scrolling = false
                this.$router.push({name: 'search', query: query})
            },

            // Scroll for more results, increment page number
            scroll: function () {
                // scroll event is on the window so we need to be sure we
                // are looking at the right route before we load
                if (!this.loading && this.more_to_load && this.$route.name == 'search') {
                    var query = Object.assign({}, this.$route.query)
                    query.page = RouteManager.nextPage()

                    // if (typeof query['page'] === "undefined") {
                    //     query['page'] = 2
                    // } else {
                    //     query['page'] = parseInt(query['page']) + 1
                    // }

                    // Instead of pushing new state ajax the results in
                    // This avoids confusing back button results
                    // this.$router.push({name: 'search', query: query})
                    this.scrolling = true
                    this.fetchResults(query)
                }
            },

            // Reload search results from page 1
            reload: function () {
                var query = Object.assign({}, this.$route.query)

                // Unset page param (start from beginning)
                RouteManager.clearPage()
                // if (query.page) {
                //     delete query.page
                // }

                this.$router.push({name: 'search', query: query})
                this.fetchResults()
            },

            // If entering grid view apply Image only filter
            exitEnterGrid: function (grid_view) {
                this.mobile_manager.grid_view = grid_view
                var field = 'searchable-has_media-keyword'
                var value = 'Images'

                if (this.mobile_manager.grid_view) {
                    FilterManager.addByField(field, value)
                } else {
                    FilterManager.removeByField(field, value)
                }

                var query = $.extend({}, FilterManager.generateQuery())
                this.$router.push({name: 'search', query: query})
                this.fetchResults()
            },

            // Request more results based on route query
            fetchResults: function (query) {

                // Originally if you went directly to an object we were
                // running the search requests as well. This resulted
                // in long load times that messed up google analytics
                // Now we only fetch search results if we are in the
                // search route
                if (this.$route.name != 'search') {
                    return;
                }

                var self = this

                // If we are already processing a request
                // don't create another request
                if (self.loading) {
                    return
                }

                if (!query) {
                    var query = $.extend({}, this.$route.query)
                }

                self.loading = true

                // Why do we clear the object array here if we
                // are just going to overwrite it later?
                // Vue will try and reuse elements resulting in
                // images being mismatched with records. Clearing
                // the array first causes the DOM to redraw.
                if (!self.scrolling) {
                    self.object_groups = []
                }

                // Fetch sorting param
                query.sort = this.actual_sort

                // reload facets with params (unless the user is scrolling)
                if (!self.scrolling) {
                    EventHub.$emit('refresh-facets')
                }

                // Make request for new data
                $.get('/api/objects', query).done(function (response) {
                    response = $.parseJSON(response)

                    // Append is scrolling else replace results
                    if (self.scrolling) {
                        self.object_groups = self.object_groups.concat(response.results)
                    } else {
                        self.object_groups = response.results
                    }

                    self.total = response.total
                    self.loading = false
                    self.scrolling = false

                    // If no results returned prevent loading anymore
                    // and revert page number if set
                    if (response.results.length == 0) {
                        self.more_to_load = false
                    }
                })
            }
        },
        watch: {
            // ARRG! getting the route to reload properly when changing route params
            // AND preventing the nested route from reloading the parent
            // was the biggest headache ever. Solution is a Singleton that
            // includes a trigger to force reload when needed
            //
            // Reload results when router changes Unless scrolling
            $route: function (to, from) {
                window.document.title = "Search - The Mariners' Museum Online Catalog"
                var description = "At The Mariners' Museum, explore over 60,000 square feet of gallery space with rare figureheads, handcrafted ship models, Civil War ironclad USS Monitor artifacts, paintings, and much more."
                $('meta[name=description]').attr('content', description)
                window.document.description = description

                ga('set', 'page', this.$route.fullPath)
                ga('send', 'pageview')

                // if (to.name == 'search' && !this.scrolling) {
                //     ga('set', 'page', this.$route.path)
                //     ga('send', 'pageview')
                //     // this.$ua.trackView(this.$route.path)
                // }
                RouteManager.setPrevious(from)

                // if we are go to and from search
                // or we want to manually force a reload
                // and we aren't scrolling
                if (((to.name == 'search' && from.name == 'search') || RouteManager.getForce()) && !this.scrolling) {
                    // Insure filters are synced with route query
                    this.filter_manager.clearAll()
                    this.filter_manager.addByQuery(this.$route.query)

                    // fetchResults
                    this.more_to_load = true
                    RouteManager.clearPage()

                    this.fetchResults()
                }

                RouteManager.setForce(false)
            }
        }
    }
</script>

<style scoped lang="scss">
    .main-padding {
        /* apply if less than 992px (bootstrap large) */
        @media (max-width: 991px) {
            padding-left: 0;
            padding-right: 0;
        }
    }
    .facet-btn {
        margin-left: 15px;
    }

    .advanced-desktop {
        margin-top: 7px;
        white-space: nowrap;
        text-align: right;
    }

    .facet-wrapper {
        background-color: rgba(0, 0, 0, 0.3);
        position: fixed;
        z-index: 10; /* Our z-index start at 10 b/c bootstrap uses z-index for some elements */
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
    }

    #facets {
        /* apply if less than 992px (bootstrap large) */
        @media (max-width: 991px) {
            right: 0;
            z-index: 12;
            width: 250px;
            background-color: white;
            position: absolute;
        }
    }

    #facets::after {
        bottom: 100%;
        right: 33px;
        border: solid transparent;
        content: " ";
        height: 0;
        width: 0;
        position: absolute;
        pointer-events: none;
        border-bottom-color: white;
        border-width: 10px;
        margin-left: -10px;
    }

    .mobile-sort-by {
        margin-top: 15px;
        select {
            display: inline-block;
            width: 170px;
        }
    }

    .display-block {
        display: block;
    }

    .mobile-wrapper {
        margin-top: 5px;

        div.col-md-12 {
            padding-left: 15px;
            padding-right: 10px;
        }
    }

    .search-wrapper {
        .mobile-search {
            input {
                border-right-style: none;
            }
            .btn {
                /* rounded corner on right side only */
                -webkit-border-top-right-radius: 4px;
                -webkit-border-bottom-right-radius: 4px;
                -moz-border-radius-topright: 4px;
                -moz-border-radius-bottomright: 4px;
                border-top-right-radius: 4px;
                border-bottom-right-radius: 4px;
                border: 1px solid #ccc;
                border-left-style: none;
                background-color: transparent;
            }
        }

        img {
            width: 18px;
        }
    }

    .loader {
        margin-bottom: 25%;
    }

    .no-results {
        width: 200px;
    }

    #result-format {
        margin-top: 20px;
        margin-bottom: 10px;
    }

    .view-controls {
        label {
            padding-right: 5px;
        }
        .form-group {
            margin-left: 15px;
        }
    }

</style>
